export const locale = {
    lang: 'pt',
    data: {
        HELPER: {
            TIME: {
                FORMAT_DATE_WITH_HOUR: 'dd/MM/yyyy HH:mm',
                FORMAT_SECOND: 'a {{ seconds }} segundo atrás',
                FORMAT_SECONDS: 'a {{ seconds }} segundos atrás',
                FORMAT_MINUTE: 'a {{ minutes }} minuto atrás',
                FORMAT_MINUTES: 'a {{ minutes }} minutos atrás',
                FORMAT_HOUR: 'a {{ hours }} hora atrás',
                FORMAT_HOURS: 'a {{ hours }} horas atrás',
            },
            LABEL: {
                DELIVERY_ROUTE_PERIOD: {
                    MORNING: 'Manhã',
                    AFTERNOON: 'Tarde',
                },
                PEOPLE_TYPE: {
                    CUSTOMER: 'Cliente',
                    EMPLOYEE: 'Funcionário',
                    SUPPLIER: 'Fornecedor',
                },
                LABEL_TYPE: {
                    BROTHER_62_30: 'Brother 62x30 mm',
                    PIMACO_28_51: 'Pimaco 28x51 mm (SLP-MRL)',
                    PIMACO_28_89: 'Pimaco 28x89 mm (SLP-2RLH)',
                    PIMACO_36_89: 'Pimaco 36x89 mm (SLP-2RLE)',
                    PIMACO_54_101: 'Pimaco 54x101 mm (SLP-SRL)',
                    ZEBRA_80_50: 'Zebra 80x50 mm',
                    ZEBRA_50_30: 'Zebra 50x30 mm',
                    ZEBRA_50_30_X2: 'Zebra 50x30 mm - 2 colunas',
                },
                LABEL_IDENTIFICATION_CODE: {
                    QR_CODE: 'QR Code',
                    BAR_CODE: 'Código de barra',
                },
                LABEL_IDENTIFICATION_TYPE: {
                    ORDER: 'Dados do pedido',
                    ADDRESS: 'Endereço',
                    ITEMS: 'Itens',
                },
                OUTSOURCE_STATUS: {
                    PENDING: 'Enviado',
                    FINISH: 'Finalizado',
                    DELAYED: 'Atrasado',
                },
                EQUIPMENT_TYPE: {
                    SCANNER: 'Scanner',
                    MILLING: 'Fresadora',
                    PRINTER: 'Impressora',
                    FURNACE: 'Forno',
                    OTHER: 'Outro',
                },
                ORDER_ITEM_TYPES: {
                    PRODUCT: 'Produto',
                    SERVICE: 'Serviço',
                },
                COMMISSION_INCLUDE_TYPE: {
                    ORDER: 'Pedidos finalizados',
                    STAGE: 'Etapas finalizadas',
                },
                COMMISSION_CALC_BASIS: {
                    GROSS_VALUE: 'Valor bruto do serviço',
                    NET_VALUE: 'Valor líquido do serviço',
                },
                CUSTOMER_STATUS: {
                    ACTIVE: {
                        ACTIVE: 'Ativo',
                        TEMPORARY: 'Ativo temporariamente',
                    },
                    LEAD: 'Prospect',
                    INACTIVE: 'Inativo',
                    BLOCKED: 'Bloqueado',
                },
                DENTISTRY_DENTAL_NOTATION: {
                    FDI_NOTATION: 'FDI Notation',
                    UNIVERSAL_SYSTEM: 'Universal System',
                    PALMER_NOTATION: 'Palmer Notation',
                },
                INVOICE_TYPE: {
                    BIWEEKLY: 'Quinzenal',
                    MONTHLY: 'Mensal',
                },
                REGISTRATION_TYPE: {
                    PERSONAL: 'Pessoa Física',
                    BUSINESS: 'Pessoas Jurídica',
                },
                PHONE_TYPES: {
                    HOME: 'Casa',
                    MOBILE: 'Celular',
                    WORK: 'Trabalho',
                    OTHER: 'Outros',
                },
                EMPLOYEE_STATUS: {
                    ACTIVE: 'Ativo',
                    INACTIVE: 'Inativo',
                },
                KIWID_PLAN_SOFTWARE_LEVEL: {
                    PRO: 'Pro',
                    BASIC: 'Basic',
                    ESSENTIAL: 'Essential',
                },
                SUPPLIER_STATUS: {
                    ACTIVE: 'Ativo',
                    INACTIVE: 'Inativo',
                },
                SUPPLIER_TYPES: {
                    BUSINESS: 'Jurídica',
                    NATURAL: 'Física',
                },
                PAYMENT_METHOD: {
                    CASH: 'Dinheiro',
                    CHECK: 'Cheque',
                    ACCOUNT_CREDIT: 'Crédito em conta',
                    BANK_SLIP: 'Boleto',
                    CREDIT_CARD: 'Cartão de crédito',
                    DEBIT_CARD: 'Cartão de débito',
                    ONLINE_CARD: 'Cartão de crédito online',
                    ONLINE_BANK_SLIP: 'Boleto online',
                    TRANSFER: 'Transferência',
                    DIRECT_DEBIT: 'Débito em conta',
                    ACCOUNT_TRANSFER: 'Transferência de contas',
                    PIX: 'Pix',
                    NONE: '-',
                },
                ORDER_STATUS: {
                    DRAFT: 'Rascunho',
                    NEW: 'Novo',
                    APPROVAL: 'Aprovação',
                    PENDING: 'Pendente',
                    PRODUCTION: 'Produção',
                    PROOF: 'Prova',
                    DELAYED: 'Atrasado',
                    FINISHED: 'Finalizado',
                    DELIVERED: 'Entregue',
                    CANCELLED: 'Cancelado',
                    SUSPENDED: 'Suspenso',
                },
                PRODUCTION_STATUS: {
                    PENDING: 'Pendente',
                    ACTIVE: 'Iniciado',
                    FINISHED: 'Finalizado',
                    CANCELED: 'Cancelado',
                },
                GENDER: {
                    MALE: 'Masculino',
                    FEMALE: 'Feminino',
                    NOT_BINARY: 'Não binário',
                },
                ORDER_TYPE: {
                    ORDER: 'Pedido',
                    QUOTATION: 'Orçamento',
                },
                PHONE: {
                    HOME: 'Casa',
                    MOBILE: 'Celular',
                    WORK: 'Trabalho',
                    OTHER: 'Outros',
                },
                INVOICE_STATUS: {
                    OPEN: 'Em aberto',
                    CLOSED: 'Fechado',
                    PAID: 'Pago',
                    CANCELLED: 'Cancelado',
                },
                RECEIVABLE_STATUS: {
                    PENDING: 'Pendente',
                    CANCELLED: 'Cancelado',
                    PAID: 'Pago',
                    REFUSED: 'Recusado',
                    REFUNDED: 'Estornado',
                    DISPUTE: 'Em disputa',
                    CHARGEBACK: 'Chargeback',
                },
                RECEIVABLE_TOOLTIP_STATUS: {
                    PENDING: 'Transação pendente',
                    OVERDUE: 'Transação vencida',
                    DUE_DATE_TODAY: 'Transação vence hoje',
                    CANCELLED: 'Transação cancelada',
                    PAID: 'Transação paga',
                    REFUSED: 'Transação recusada',
                    REFUNDED: 'Transação estornada',
                    DISPUTE: 'Transação em disputa de chargeback',
                    CHARGEBACK: 'Transação com chargeback',
                },
                CREDIT_CARD_BRAND: {
                    VISA: 'Visa',
                    MASTERCARD: 'Mastercard',
                    AMERICAN_EXPRESS: 'American express',
                    ELO: 'Elo',
                    HIPERCARD: 'hipercard',
                    HIPER: 'Hiper',
                    DISCOVER: 'Discover',
                    DINERS: 'Diners',
                    AURA: 'Aura',
                    JCB: 'Jcb',
                    CABAL: 'Cabal',
                    BANESCARD: 'Banescard',
                },
                TRANSFER_INTERVAL: {
                    DAILY: 'Diário',
                    WEEKLY: 'Semanal',
                    MONTHLY: 'Mensal',
                },
                LOCATION_STATUS: {
                    TRIAL_EXPIRES: 'TRIAL EXPIRA EM {{ days }} DIAS. ADQUIRA!',
                    TRIAL_EXPIRES_ONE_DAY: 'TRIAL EXPIRA EM {{ days }} DIA. ADQUIRA!',
                    LOCATION_TRIAL_EXPIRES: '{{ locationName }}: TRIAL EXPIRA EM {{ days }} DIAS. ADQUIRA!',
                    LOCATION_TRIAL_EXPIRES_ONE_DAY: '{{ locationName }}: TRIAL EXPIRA EM {{ days }} DIA. ADQUIRA!',
                    DEBTOR: 'SEU PAGAMENTO ESTÁ EM ATRASO. VERIFIQUE JÁ!',
                    LOCATION_DEBTOR: '{{ locationName }}: SEU PAGAMENTO ESTÁ EM ATRASO. VERIFIQUE JÁ!',
                    TRIAL_ENDED: 'SEU PERÍODO DE TRIAL ACABOU. ADQUIRA!',
                    LOCATION_TRIAL_ENDED: '{{ locationName }}: SEU PERÍODO DE TRIAL ACABOU. ADQUIRA!',
                },
                STOCK_KEY: {
                    NEW_STOCK: 'Novo estoque',
                    RETURN: 'Retorno',
                    TRANSFER: 'Transferência',
                    INTERNAL_USE: 'Uso interno',
                    DAMAGED: 'Danificado',
                    OUT_OF_DATE: 'Vencido',
                    ADJUSTMENT: 'Ajuste',
                    LOST: 'Perda',
                    REMAKE: 'Repetição',
                    OTHER: 'Outros',
                    STOCK_ENABLED: 'Monitoramento estoque habilitado',
                    STOCK_DISABLED: 'Monitoramento estoque desabilitado',
                    SALE: 'Pedido ',
                    ORDER_REOPEN: 'Reaberto pedido ',
                    ORDER_CANCELLED: 'Cancelado pedido ',
                    ORDER_DELETED: 'Excluído pedido ',
                    ITEM_DELETED: 'Excluído item do pedido ',
                    INVENTORY_ORDER_CANCELLED: 'Cancelado compra ',
                    INVENTORY_ORDER_DELETED: 'Excluído compra ',
                },
                DELIVERY_ROUTE_STATUS: {
                    PENDING: 'Programado',
                    SCHEDULED: 'Liberado',
                    FINISHED: 'Entregue',
                },
                PAYMENT_DESCRIPTION: {
                    PAYMENT: {
                        CASH: 'Pagamento em dinheiro',
                        CHECK: 'Pagamento em cheque',
                        ACCOUNT_CREDIT: 'Pagamento em crédito em conta',
                        BANK_SLIP: 'Pagamento em boleto',
                        CREDIT_CARD: 'Pagamento em cartão de crédito',
                        CREDIT_CARD_FREQUENCY: 'Pagamento de cartão de crédito parcelado',
                        DEBIT_CARD: 'Pagamento em cartão de débito',
                        ONLINE_CARD: 'Pagamento em cartão de crédito online',
                        ONLINE_BANK_SLIP: 'Pagamento em boleto online',
                        CANCEL: {
                            BANK_SLIP: 'Cancelamento de boleto',
                            CHECK: 'Cancelamento de cheque',
                            CASH: 'Cancelamento de dinheiro',
                            ACCOUNT_CREDIT: 'Cancelamento de crédito em conta',
                            CREDIT_CARD: 'Cancelamento de cartão de crédito',
                            DEBIT_CARD: 'PCancelamento de cartão de débito',
                            ONLINE_CARD: 'Cancelamento de cartão de crédito online',
                            ONLINE_BANK_SLIP: 'Cancelamento de boleto online',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Estorno do cartão online',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Charged back do cartão online',
                        },
                    },
                    INSTALLMENT: {
                        EMPTY: 'Pagamento parcelado',
                        CASH: 'Pagamento parcelado em dinheiro',
                        CHECK: 'Pagamento parcelado em cheque',
                        ACCOUNT_CREDIT: 'Pagamento parcelado em crédito em conta',
                        BANK_SLIP: 'Pagamento parcelado em boleto',
                        CREDIT_CARD: 'Pagamento parcelado em cartão de crédito',
                        DEBIT_CARD: 'Pagamento parcelado em cartão de débito',
                        ONLINE_CARD: 'Pagamento parcelado em cartão de crédito online',
                        ONLINE_BANK_SLIP: 'Pagamento parcelado em boleto online',
                        CANCEL: {
                            BANK_SLIP: 'Parcela cancelada de boleto',
                            CHECK: 'Parcela cancelada de cheque',
                            CASH: 'Parcela cancelada de dinheiro',
                            ACCOUNT_CREDIT: 'Parcela cancelada de crédito em conta',
                            CREDIT_CARD: 'Parcela cancelada de cartão de crédito',
                            DEBIT_CARD: 'Parcela cancelada de cartão de débito',
                            ONLINE_CARD: 'Parcela cancelada de cartão de crédito online',
                            ONLINE_BANK_SLIP: 'Parcela cancelada de boleto online',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Parcela estornada de cartão online',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Parcela charged back de cartão online',
                        },
                    },
                },
                KEY_MOVEMENTS: {
                    OTHER: 'Outros',
                    DISCOUNT: 'Desconto',
                    REFUND: 'Estorno',
                    ORDER: 'Pedido',
                    PAYMENT: 'Pagamento',
                    INITIAL_BALANCE: 'Saldo inicial',
                },
                MEDIA_TYPE: {
                    PRIVATE: 'Privado',
                    PUBLIC: 'Público',
                },
                ACCOUNT_BANK: {
                    CHECKING_ACCOUNT: 'Conta corrente',
                    SAVINGS_ACCOUNT: 'Conta poupança',
                    CASH_ACCOUNT: 'Conta interna',
                    CREDIT_CARD_ACCOUNT: 'Cartão de crédito',
                    DIGITAL_ACCOUNT: 'Conta digital',
                },
                PIX_KEY: {
                    DOCUMENT: 'CPF/CNPJ',
                    PHONE: 'Telefone',
                    EMAIL: 'E-mail',
                    RANDOM: 'Aleatória',
                },
                MOVEMENT_PAYMENT_DESCRIPTION: {
                    PAYMENT: 'Pagamento',
                    REFUND_PAYMENT: 'Pagamento de estorno',
                    CANCEL: 'Cancelado',
                    GENERATE: 'Gerado',
                    PAYMENT_CASH: 'Pagamento à vista',
                    PAYMENT_INSTALLMENT: 'Pagamento {{ installment }}x',
                    PAYMENT_INSTALLMENT_DESCRIPTION: {
                        DEFAULT: 'Pagamento em {{ installment }}x',
                        CANCELLED: 'Cancelado: Pagamento parcela {{ installmentNumber }}',
                    },
                    REFUND: 'Estorno',
                },
                MOVEMENT_PAYMENT_SUB_DESCRIPTION: {
                    DATE_FORMAT: 'dd/MM/yyyy',
                    ACCOUNT_NAME: 'Conta: {{ accountName }}',
                    NF_NAME: 'NF: {{ nfName }}',
                    DUE_DATE: 'Venc: {{ dueDate }}',
                    CHECK: {
                        NUMBER: 'Número',
                        NAME: 'Nome',
                        DATE: 'Bom para',
                    },
                },
                RELATIVE_TYPES: {
                    PARTNER: 'Marido, esposa',
                    FATHER: 'Pai',
                    MOTHER: 'Mãe',
                    BROTHER_SISTER: 'Irmã(o)',
                    SON_DAUGHTER: 'Filha(o)',
                    FRIEND: 'Amigo',
                    OTHER: 'Outro',
                },
                INVENTORY_ORDER_STATUS: {
                    DRAFT: 'Rascunho',
                    APPROVAL: 'Em aprovação',
                    ORDERED: 'Solicitado',
                    PARTIAL: 'Parcial',
                    RECEIVED: 'Recebido',
                    CANCELLED: 'Cancelado',
                },
                LAMBDA: {
                    REPORT_ORDER_EQUIPMENT_DETAIL: 'Equipamentos',
                    REPORT_ORDER_EQUIPMENT_BY_EQUIPMENT: 'Equipamentos',
                    REPORT_ORDER_EQUIPMENT_BY_STAGE: 'Equipamentos',
                    REPORT_ORDER_DETAILED: 'Pedidos detalhados',
                    REPORT_ORDER_FINISHED: 'Pedidos finalizados',
                    REPORT_ORDER_PENDING: 'Pedidos pendentes',
                    REPORT_FINANCIAL_PAYMENT_LINK: 'Link de pagamento',
                    REPORT_FINANCIAL_DEBIT_CREDIT_BALANCE: 'Devedores / Credores',
                    REPORT_FINANCIAL_RECEIPT: 'Recibos emitidos',
                    REPORT_ORDER_OUTSOURCE: 'Terceirizados',
                    REPORT_ORDER_RATING: 'Avaliações de pedidos',
                    REPORT_SERVICE_PRODUCTION_BY_MONTH: 'Produção mês a mês de serviço',
                    REPORT_EMPLOYEE_PRODUCTION_SCHEDULE: 'Agenda de produção',
                    REPORT_SERVICE_STAGE: 'Serviços e Etapas',
                    APP_PRICE_TABLE: 'Tabela de preço',
                    APP_PRODUCTION_SCHEDULE: 'Agenda de produção',
                    REPORT_FINANCIAL_REVENUE: 'Faturamento',
                    REPORT_INVENTORY_ORDER_DETAIL: 'Compras detalhada',
                    REPORT_INVENTORY_ORDER_PRODUCT: 'Compras por produtos',
                    REPORT_INVENTORY_ORDER_SUPPLIER: 'Compras por fornecedores',
                    REPORT_INVENTORY_ORDER_PERIOD: 'Compras por período',
                },
            },
            PDF: {
                DATE_FORMAT: 'dd/MM/yyyy',
                DATETIME_FORMAT: 'dd/MM/yyyy HH:mm:ss',
                USER: 'Usuário',
                RECEIVABLES: {
                    ACCOUNT: 'Conta bancária',
                    EXPENSE: 'Despesas',
                    INCOME: 'Recebimentos',
                    RECURRENT: 'Recorrente',
                    TABLE: {
                        THEAD: {
                            DATE: 'Data',
                            PEOPLE_INCOME: 'Recebido de',
                            PEOPLE_EXPENSE: 'Pago a',
                            DESCRIPTION: 'Descrição',
                            EXTERNAL_INVOICE_NUMBER: 'Nº nota fiscal',
                            GROSS_VALUE: 'Valor bruto',
                            NET_VALUE: 'Valor líquido',
                            DUE_DATE: 'Vencimento',
                            PAYMENT_METHOD_EXPENSE: 'Forma de receb.',
                            PAYMENT_METHOD_INCOME: 'Forma de pag.',
                            STATUS: 'Status',
                        },
                        TBODY: {
                            ACCRUAL_DATE: 'Comp.: {{date}}',
                        },
                    },
                    RESUME_TOTAL: {
                        GROSS_VALUE: 'Valor bruto',
                        TAX: 'Taxas',
                        RATE: 'Juros',
                        DISCOUNT: 'Descontos',
                        NET_VALUE: 'Valor líquido',
                        PAID_INCOME: 'Total recebido',
                        UNPAID_INCOME: 'Total a receber',
                        PAID_EXPENSE: 'Total pago',
                        UNPAID_EXPENSE: 'Total a pagar',
                    },
                },
                PAYMENT_DESCRIPTION: {
                    PAYMENT: {
                        CASH: 'Pagamento em dinheiro',
                        CHECK: 'Pagamento em cheque',
                        ACCOUNT_CREDIT: 'Pagamento em crédito em conta',
                        BANK_SLIP: 'Pagamento em boleto',
                        CREDIT_CARD: 'Pagamento em cartão de crédito',
                        CREDIT_CARD_FREQUENCY: 'Pagamento de cartão de crédito parcelado',
                        DEBIT_CARD: 'Pagamento em cartão de débito',
                        ONLINE_CARD: 'Pagamento em cartão de crédito online',
                        ONLINE_BANK_SLIP: 'Pagamento em boleto online',
                        CANCEL: {
                            BANK_SLIP: 'Cancelamento de boleto',
                            CHECK: 'Cancelamento de cheque',
                            CASH: 'Cancelamento de dinheiro',
                            ACCOUNT_CREDIT: 'Cancelamento de crédito em conta',
                            CREDIT_CARD: 'Cancelamento de cartão de crédito',
                            DEBIT_CARD: 'PCancelamento de cartão de débito',
                            ONLINE_CARD: 'Cancelamento de cartão de crédito online',
                            ONLINE_BANK_SLIP: 'Cancelamento de boleto online',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Estorno do cartão online',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Charged back do cartão online',
                        },
                    },
                    INSTALLMENT: {
                        EMPTY: 'Pagamento parcelado',
                        // EMPTY_COUNT: 'Pagamento parcelado em {{installmentTotal}}x',
                        CASH: 'Pagamento parcelado em dinheiro',
                        CHECK: 'Pagamento parcelado em cheque',
                        ACCOUNT_CREDIT: 'Pagamento parcelado em crédito em conta',
                        BANK_SLIP: 'Pagamento parcelado em boleto',
                        CREDIT_CARD: 'Pagamento parcelado em cartão de crédito',
                        DEBIT_CARD: 'Pagamento parcelado em cartão de débito',
                        ONLINE_CARD: 'Pagamento parcelado em cartão de crédito online',
                        ONLINE_BANK_SLIP: 'Pagamento parcelado em boleto online',
                        CANCEL: {
                            BANK_SLIP: 'Parcela cancelada de boleto',
                            CHECK: 'Parcela cancelada de cheque',
                            CASH: 'Parcela cancelada de dinheiro',
                            ACCOUNT_CREDIT: 'Parcela cancelada de crédito em conta',
                            CREDIT_CARD: 'Parcela cancelada de cartão de crédito',
                            DEBIT_CARD: 'Parcela cancelada de cartão de débito',
                            ONLINE_CARD: 'Parcela cancelada de cartão de crédito online',
                            ONLINE_BANK_SLIP: 'Parcela cancelada de boleto online',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Parcela estornada de cartão online',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Parcela charged back de cartão online',
                        },
                    },
                },
            },
            ERROR_INTERCEPTOR: {
                SYSTEM_ERROR: {
                    CONFIRM: {
                        BUTTONS: {
                            CONFIRM: 'Confirmar',
                            CANCEL: 'Cancelar',
                        },
                    },
                    WARNING: {
                        BUTTONS: {
                            CONFIRM: 'Entendi',
                        },
                    },
                },
            },
        },
    },
};
